import React, { useState } from 'react';
import { DrillFile } from "../typings";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { MdOutlineMoreVert } from "react-icons/md";
import ConfirmationDialog from "../tags/ConfirmationDialog";
import AddToPackagesDialog from "./AddToPackagesDialog";
import RemoveFromPackagesDialog from "./RemoveFromPackagesDialog";
import { addDrill, removeDrill } from "./drills-api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ApiContextType } from "../api-context";

interface Props {
    api: ApiContextType;
    drill: DrillFile;
    onRemove: (id: number) => void;
}

function DrillRow(props: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [addDialogOpen, setAddDialogOpen] = useState(false);
    const [removeDialogOpen, setRemoveDialogOpen] = useState(false);

    const navigate = useNavigate();

    const onAdd = (ids: number[]) => {
        addDrill(props.api, props.drill.id, ids)
            .then(() => toast.success("Successfully added files to packages"))
            .catch(() => toast.error("Failed to add file to packages!"))
            .finally(() => setAddDialogOpen(false));
    };

    const onRemove = (ids: number[]) => {
        removeDrill(props.api, props.drill.id, ids)
            .then(() => toast.success("Successfully removed files from packages"))
            .catch(() => toast.error("Failed to remove file from packages!"))
            .finally(() => setRemoveDialogOpen(false));
    };

    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '12px 16px',
            width: '100%',
            alignItems: 'center'
        }}>
            <div className="drill-row-item" style={{flex: 2, cursor: 'pointer'}} onClick={() => navigate(`/file/${props.drill.id}`)}>{props.drill.name}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.drill.createdAt?.split(' ')[0]}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.drill.updatedAt?.split(' ')[0]}</div>
            <div className="drill-row-item" style={{flex: 2}}>{props.drill.updatedBy}</div>
            <Menu>
                <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                <MenuItems
                    className="menu-box"
                    anchor="bottom"
                >
                    <MenuItem>
                        <div className="menu-item" onClick={() => navigate(`/file/${props.drill.id}`)}>
                            Edit
                        </div>
                    </MenuItem>
                    <MenuItem>
                        <div className="menu-item" onClick={() => setAddDialogOpen(true)}>
                            Add to packages
                        </div>
                    </MenuItem>
                    <MenuItem>
                        <div className="menu-item" onClick={() => setRemoveDialogOpen(true)}>
                            Remove from packages
                        </div>
                    </MenuItem>
                    <MenuItem>
                        <div className="menu-item" onClick={() => setDialogOpen(true)}>
                            Remove
                        </div>
                    </MenuItem>
                </MenuItems>
            </Menu>
            <ConfirmationDialog
                title="Delete file"
                description="Are you sure you want to delete this file?"
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={() => {
                    props.onRemove(props.drill.id);
                    setDialogOpen(false);
                }}
            />
            <AddToPackagesDialog
                id={props.drill.id}
                open={addDialogOpen}
                api={props.api}
                onClose={() => setAddDialogOpen(false)}
                onConfirm={onAdd}
            />
            <RemoveFromPackagesDialog
                id={props.drill.id}
                api={props.api}
                open={removeDialogOpen}
                onClose={() => setRemoveDialogOpen(false)}
                onConfirm={onRemove}
            />
        </div>
    );
}

export default DrillRow;
